// 表单字段 key → 中文标签的公共映射，供各页面的 getLabel 使用

// 软件基本信息字段（apply / protect / confirm 等页面共用）
export const SOFTWARE_FIELD_LABELS = {
  applicant: '著作权人',
  softwareName: '软件全称',
  shortName: '软件简称',
  version: '版本号',
  devHardware: '开发的硬件环境',
  runHardware: '运行的硬件环境',
  devSystem: '开发的操作系统',
  devTools: '软件开发环境/开发工具',
  runSystem: '该软件的运行平台/操作系统',
  runSupport: '软件运行支撑环境/支持软件',
  programLanguage: '编程语言',
  programAmount: '源程序量',
  industry: '面向领域/行业',
  classify: '软件分类',
  purpose: '开发目的',
  features: '软件的主要功能',
  characteristics: '软件技术特点'
};

// 申请材料类字段（correction 等页面使用）
export const MATERIAL_FIELD_LABELS = {
  sealMaterialPages: '签章材料',
  otherProveMaterials: '其他相关证明文件',
  programIdentifyMaterial: '程序鉴别材料',
  documentIdentifyMaterial: '文档鉴别材料',
  preDevelopmentInstructions: '前期开发说明',
  cooperateContract: '合作开发合同',
  commissionContract: '委托开发合同',
  taskContract: '下达任务的项目任务书或合同'
};

// 根据映射表生成 getLabel，未匹配的 key 返回空字符串
export const createGetLabel = labels => key => labels[key] ?? '';
